export default __webpack_public_path__ + "static/media/nu.6c2313ad.svg";